import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["NativoTout"] */ "/app/src/app/_components/ads/NativoTout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickyFooterPortal"] */ "/app/src/app/_components/ads/StickyFooterPortal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InStreamAd"] */ "/app/src/app/_components/Article/ads/InStreamAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RightRail"] */ "/app/src/app/_components/Article/ads/RightRail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleSourceBanner"] */ "/app/src/app/_components/Article/ArticleHeader/components/GoogleSourceBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleSourceButton"] */ "/app/src/app/_components/Article/ArticleHeader/components/GoogleSourceButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/Article/components/ArticleVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleWrapper"] */ "/app/src/app/_components/Article/components/ArticleWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VodVideo"] */ "/app/src/app/_components/Article/components/VodVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RelatedVideo"] */ "/app/src/app/_components/Article/embeds/RelatedVideo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/Article/Related/LatestArticles.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/Article/Related/MostPopular.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/AbTest.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActionableIcon"] */ "/app/src/app/_components/common/ActionableIcon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Icon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/iframe.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Image.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/app/src/app/_components/common/Logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialLinksDropdown"] */ "/app/src/app/_components/common/SocialLinksDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdminBar"] */ "/app/src/app/_components/dev/AdminBar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/Outbrain/Outbrain.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InlineArticlePianoTemplate"] */ "/app/src/app/_components/PianoTemplateContainers/InlineArticlePianoTemplate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrinityPlayerScript"] */ "/app/src/app/_components/TrinityPlayer/TrinityPlayerScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BasicPopover"] */ "/app/src/app/_components/ui/BasicPopover.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/src/app/_components/ui/Button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/ui/ButtonV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root"] */ "/app/src/app/_components/ui/primitives/Separator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/app/src/app/_components/ui/Tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionDescription"] */ "/app/src/app/_components/widgets/common/AccordionDescription.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/widgets/RatesWidget/ClientWidgets.tsx");
